import styled from 'styled-components'

export default function Disclaimer() {
  return (
    <StyledText>
      3D-malli on suuntaa antava ja perustuu 11/2023 aikaisiin suunnitelmiin.
      Ympäröivän alueen rakentamattomat kohteet on mallinnettu 11/2023
      asemakaavan mukaisesti. Asuntokohtaisista yksityiskohdista ja tarkoista
      suunnitelmista saat lisätietoa asuntomyynniltä.
    </StyledText>
  )
}

const StyledText = styled.p`
  position: absolute;
  top: 10px;
  left: 20px;
  color: #747577;
  user-select: none;
  -webkit-user-select: none;

  @media (max-width: 575px) {
    font-size: 10px;
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 850px) and (-webkit-min-device-pixel-ratio: 2) and (orientation: landscape) {
    font-size: 10px;
  }

  @media only screen and (min-device-width: 320px) and (max-device-width: 850px) and (min--moz-device-pixel-ratio: 2) and (orientation: landscape) {
    font-size: 10px;
  }
`
